/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty, sortBy, delay } from "lodash";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import Filters from "../../../components/Filters";
import PageHeader from "../../../components/PageHeader";
import { ControlTable } from "../../../components/Table";
import useForm from "../../../hooks/useForm";
import { getParams } from "../../../utils/params";
import CommentIcon from "../../../assets/images/icon/comment-icon.svg";
import Icon from "../../../components/Icon";
import { COUNSELING_SEARCH_OPTIONS, COUNSELING_CATEGORY_TYPES } from "../../../constants/COUNSELING";
import Profile from "../../../components/Profile";
import { getManagerCounselingList } from "../../../apis/admin/counseling";
import CounselingDetail from "../../Counseling/CounselingDetail";

import { toast } from "../../../utils/toast";
import systemAlert from "../../../utils/systemAlert";
import { deleteCounseling } from "../../../apis/counseling/counseling";

const CounselingList = () => {
  const [counselingType,] = useState("all");
  const [mode, setMode] = useState('create');
  const [myCompany, setMyCompany] = useState({});
  const [readType, setReadType] = useState("all");
  const { user, companies, employee, company, careCompanies } = useSelector(
    (store) => ({
      user: store.Profile.user,
      companies: store.Data.companies,
      employee: store.Profile.employee,
      company: store.Profile.company,
      careCompanies: store.Data.careCompanies,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (!isEmpty(user) && !isEmpty(companies))
      setMyCompany(companies.find((com) => com.companyIdx === user.managerCompanyIdx));
  }, [user, companies]);

  const rowBtnConfig = {
    rowButtons: [
      {
        isHide: (data) => {
          return data.writerEmployeeIdx !== employee.employeeIdx;
        },
        label: "삭제",
        type: "delete",
        action: (data) => {
          systemAlert(`"${data.title}" 삭제하시겠습니까?`, {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '삭제',
                onClick: () => {
                  setIsLoading(true);
                  deleteCounseling(counselingType, data.idx)
                    .then(() => {
                      submit(form);
                      systemAlert('삭제 되었습니다.');
                    })
                    .catch((err) => {
                      setIsLoading(false);
                    });
                }
              }
            ]
          });
        },
      },
      {
        isHide: (data) => {
          return data.writerEmployeeIdx !== employee.employeeIdx;
        },
        label: "수정",
        type: "edit",
        action: (data) => {
          setMode('modify');
          setDetailOpen(true);
          setSelectedCounseling(data);
        },
      },
    ],
  };

  const [notices,] = useState([]);
  const [fields, setFields] = useState([]);
  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedCounseling, setSelectedCounseling] = useState(null);

  const [filters, setFilters] = useState([]);

  const {
    form,
    setForm,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    reSubmit,
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(
    {
      searchType: 'titleAndContent',
      searchText: '',
      searchCategory: '999',
      searchCareCompany: '0',
      readType: 'all',
      isMe: true,
      page: 0,
      limit: 10,
      order: [
        {
          createdTime: "desc",
        },
      ]
    },
  );

  useEffect(() => {
    if (!isEmpty(employee)) {
      const fields = [
        {
          key: 'count',
          width: '100px'
        },
        {
          title: "카테고리",
          className: 'text-align-left',
          key: "category",
          onValue: (value) => {
            return COUNSELING_CATEGORY_TYPES.find((item) => Number(item.value) === Number(value)).label;
          },
        },
        {
          title: "관리기업",
          className: 'text-align-left',
          key: "company.name",
        },
        {
          title: "제목",
          className: 'text-align-left',
          key: "title",
          onValue: (value, _, d) => {

            const isNew = (employee.companyIdx !== d.writerEmployee?.companyIdx && isEmpty(d.viewEmployee));

            const isUpdate = ((employee.companyIdx !== d.writerEmployee?.companyIdx && isEmpty(d.viewTime))
              || (d?.comments?.comments || []).find(f =>
                employee.employeeIdx === f.writerEmpIdx ? readType === "care_read" ? !f.isRead : false : !f.isRead
              ));

            return (
              <>
                {value === 'null' || isEmpty(value) ? <span className="color-red-80">삭제된 게시글 입니다.</span> :
                  <span className={`${!isNew && !isUpdate ? "" : "font-bold"}`}>
                    {value}
                  </span>
                }

                {isNew ? !isEmpty(value) && <small className="color-red-100 font-size-10 ml-2 display-inline">new</small>
                  : isUpdate ? !isEmpty(value) && <small className="color-red-100 font-size-10 ml-2 display-inline">edited</small> : <></>
                }
              </>
            );
          },
        },
        {
          title: "주담당자",
          key: "managers",
          onValue: (data) => {
            let count = 0;
            return (
              !isEmpty(data) &&
              data.map((manager, idx) => {
                if (manager.level === 1) {
                  if (count === 0) {
                    count++;
                    return manager.employee.name;
                  } else {
                    return ',' + manager.employee.name;
                  }
                }
              }
              ));
          }
        },
        {
          title: "작성자",
          key: "writerEmployee",
          onValue: (data, fields, datas) => {
            return <Profile data={data} className={`${datas.isManagerWrite ? 'font-bold' : ''}`} />;
          }
        },
        { title: "작성일시", key: "createdTime", type: 'datetime' },
        {
          title: "읽은사람", key: "viewEmployee",
          onValue: (data, fields, datas) => {
            return data ? <Profile data={data} className={`${!datas.isManagerWrite ? 'font-bold' : ''}`} /> : '-';
          }
        },
        { title: "읽은시간", key: "viewTime", type: 'datetime' },
        {
          title: '',
          key: 'comments',
          onValue: (value) => {
            return (
              !isEmpty(value) ? (
                <>
                  <Icon src={CommentIcon} />
                  <span className="ml-4 font-bold">{value.count}</span>
                </>
              ) : (<></>)
            );
          }
        },
      ];

      setFields(fields);
    }
  }, [employee, readType]);

  useEffect(() => {
    if (!isEmpty(careCompanies) && !isEmpty(myCompany) && !isEmpty(company) && !isEmpty(employee)) {
      const fields = [
        {
          title: "카테고리",
          type: "select",
          key: "searchCategory",
          options: {
            list: [{ label: "전체", value: "999" }, ...COUNSELING_CATEGORY_TYPES],
          },
        },
        {
          title: "관리기업",
          type: "select",
          key: "searchCareCompany",
          options: {
            list: [{ label: "전체", value: "0" }, ...sortBy(careCompanies.slice(1), ["name"]).map(b => ({
              label: b.name,
              value: b.companyIdx,
            }))],
          },
        },
        {
          title: "분류",
          type: "select",
          key: "searchType",
          options: {
            list: COUNSELING_SEARCH_OPTIONS,
          },
        },
        {
          title: "키워드 검색",
          type: "input",
          key: "searchText",
          placeholder: "검색어 입력",
        },
        {
          title: '주담당자',
          type: 'searchEmployees',
          key: 'managerEmployees',
        },
        {
          title: "주담당자",
          type: "checkbox",
          key: "isMe",
          label: "내 관리기업만 보기",
          checked: form.isMe,
          onChange: (checked) => {
            setForm({
              ...form,
              isMe: checked
            });
          },
        },
        {
          title: "미확인 항목 보기",
          key: "readType",
          type: "radio",
          className: "margin-right-16",
          options: {
            list: [
              { label: "전체", value: "all" },
              { label: "세무사 미확인", value: "tax_read" },
              { label: "고객사 미확인", value: "care_read" },
            ],
          },
        }
      ];

      if (myCompany.companyIdx !== company.idx) {
        setFilters([...fields.slice(0, 4), ...fields.slice(5, 7)]);
      } else {
        setFilters([...fields.slice(0, 5), ...fields.slice(6, 7)]);
      }
    }
  }, [careCompanies, myCompany, company, employee, form?.isMe]);

  useEffect(() => {
    if (isEmpty(myCompany) || isEmpty(employee)) return;
    const managerEmployees = [employee];

    setForm({
      ...form,
      managerEmployees,
    });

    submit({
      ...form,
      managerEmployees,
    });

    setSubmit(submit);
  }, [myCompany, employee]);

  useEffect(() => {
    const temps = filters;
    if (!isEmpty(temps)) {
      temps[4].checked = form.isMe;
      setForm({ readType: "all", ...(form.isMe && { searchCareCompany: "0" }) });
      setSubmit(submit);
    }
  }, [form.isMe]);


  useEffect(() => {
    if (!isEmpty(form.managerEmployees)) {
      setForm({ searchCareCompany: "0" });
    }
  }, [form.managerEmployees]);

  useEffect(() => {
    if (form.searchCareCompany > 0) {
      setForm({ managerEmployees: [], isMe: false });
    }
  }, [form.searchCareCompany]);

  const submit = ({ managerEmployees, searchCategory, searchCareCompany, isMe, ..._params }) => {

    if (isEmpty(myCompany) || isEmpty(employee)) return;

    let managerEmployeeIdx = [];
    if (myCompany.companyIdx !== company.idx) { // 관리기업 선택
      if (isMe) {
        managerEmployeeIdx = [employee.employeeIdx];
      } else {
        managerEmployeeIdx = [];
      }
    } else { // 본인기업 선택
      managerEmployeeIdx = managerEmployees.map(e => e.idx);
    }

    const careCompanyIdx = Number(searchCareCompany);

    if (!isEmpty(managerEmployeeIdx) && careCompanyIdx > 0) {
      toast.info("관리기업/주담당자를 동시에 선택 할수 없습니다. 검색 옵션을 초기화 합니다.");
      setIsLoading(false);
      delay(function() {
        window.location.reload();
      }, 3000, '');
    } else if (form.readType !== "all" && isEmpty(managerEmployees)) {
    } else {
      const params = {
        ..._params,
        managerEmployeeIdx,
        ...careCompanyIdx > 0 ? { careCompanyIdx } : {},
        ...Number(searchCategory) === 999 ? {} : { searchCategory },
      };
      setTotal(0);
      setList([]);

      const { companyIdx } = myCompany;
      setReadType(params.readType);

      setIsLoading(true);
      getManagerCounselingList(counselingType, companyIdx, getParams(params))
        .then((res) => {
          const { total, metadata, counselings, comment } = res.data;

          if (!isEmpty(counselings)) {
            setTotal(total);
            setList(counselings.map((post, index) => ({
              ...post,
              count: total - metadata.offset - index,
              comments: comment.listByPost.find(c => c.postIdx === post.idx) || {}
            })));
          }
        })
        .catch((err) => {
          console.error(err.response);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const openDetail = (data, e) => {
    if (isEmpty(data.title)) {
      toast.info("삭제된 게시글 입니다.");
      return;
    }

    setMode('view');
    setSelectedCounseling(data);
    setDetailOpen(true);

  };

  return (
    <>
      <PageHeader title="담당자 상담 관리" />
      <Filters
        isLoading={isLoading}
        filters={filters}
        submit={filterSubmit}
        form={form}
        onChange={handleOnChange}
      />
      <ControlTable
        fields={fields}
        rowBtn={rowBtnConfig}
        list={list}
        isLoading={isLoading}
        total={total}
        page={page}
        setPage={setPage}
        notices={notices}
        limit={limit}
        setLimit={setLimit}
        onSelect={openDetail}
        submit={handleSubmit}
      />
      <CounselingDetail
        counselingType={counselingType}
        //  permission={targetPermission}
        counseling={selectedCounseling}
        setCounseling={setSelectedCounseling}
        open={detailOpen}
        setOpen={setDetailOpen}
        submit={reSubmit}
        orgMode={mode}
      />
    </>
  );
};

export default CounselingList;
